module.exports = __webpack_public_path__ + "static/icons/icon-bike-0b1dfef42bd2730604f5e5956fa23b7b.svg";